<template>
  <section>
    <!--工具条-->
    <SchedulingTemplateToolbar :buttonList="buttonList" @callFunction="callFunction"></SchedulingTemplateToolbar>

    <!--列表-->
    <el-table
      :data="schedulingTemplateList"
      highlight-current-row
      v-loading="listLoading"
      @current-change="selectCurrentRow"
      style="width: 100%;"
    >
      <el-table-column fixed="left" type="index" label="序号" width="80"></el-table-column>
      <el-table-column
        fixed="left"
        label="操作"
        width="260">
        <template slot-scope="scope">
          <span v-for="item in operationButtonList" :key="item.id">
            <el-button type="text" style="padding-right:6px;" size="small" v-if="!item.IsHide" @click="operationButtonFunction(item,scope.row)">{{item.name}}</el-button>
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="LineName" label="线路名称" width="200" sortable></el-table-column>
      <el-table-column prop="DepartureTemplate" label="发车模板" width="300" sortable></el-table-column>
      <el-table-column prop="ModifyBy" label="操作人" width="200" sortable></el-table-column>
      <el-table-column prop="ModifyTime" label="操作时间" :formatter="formatModifyTime" width="200" sortable></el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="Toolbar">
      <el-pagination
        layout="total, sizes, prev, pager, next"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="page"
        :page-sizes="[10, 15, 20, 50, 100, 200]"
        :total="total"
        style="float:right;"
      ></el-pagination>
    </el-col>

    <!--编辑界面-->
    <el-dialog
      title="编辑"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm">
        <el-row>
          <el-form-item label="公交线路" prop="BusLinesId" label-width="110px">
            <el-select style="width: 100%;" v-model="editForm.BusLinesId" placeholder="请选择公交线路">
              <el-option
                v-for="item in busLinesList"
                :key="item.Id"
                :value="item.Id"
                :label="item.LineChineseName"
              >
                <span style="float: left">{{ item.LineChineseName }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="发车模版" prop="DepartureTemplate" label-width="110px">
            <el-input v-model="editForm.DepartureTemplate" auto-complete="off"></el-input>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog
      title="新增"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm">
        <el-row>
          <el-form-item label="公交线路" prop="BusLinesId" label-width="110px">
            <el-select style="width: 100%;" v-model="addForm.BusLinesId" placeholder="请选择公交线路">
              <el-option
                v-for="item in busLinesList"
                :key="item.Id"
                :value="item.Id"
                :label="item.LineChineseName"
              >
                <span style="float: left">{{ item.LineChineseName }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="发车模版" prop="DepartureTemplate" label-width="110px">
            <el-input v-model="addForm.DepartureTemplate" auto-complete="off"></el-input>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--操作日记-->
    <el-dialog
      title="操作日记"
      :visible.sync="operateDataLogFormVisible"
      v-model="operateDataLogFormVisible"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      width="60%"
    >
      <OperateDataLog v-if="operateDataLogFormVisible" :entityName="entityName" :entityKey="entityKey"></OperateDataLog>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="operateDataLogFormVisible = false">关闭</el-button>
      </div>
    </el-dialog>

  </section>
</template>

<script>
import util from "../../../util/date";
import { getSchedulingTemplateListPage, getBusLinesListPage, addSchedulingTemplate, editSchedulingTemplate, removeSchedulingTemplate } from "../../api/api";
import { getButtonList,getOperationButtonList } from "../../promissionRouter";
import SchedulingTemplateToolbar from "../../components/QueryToolbar/SchedulingTemplateToolbar";
import OperateDataLog from "../../components/OperateDataLog";

export default {
  components: { SchedulingTemplateToolbar,OperateDataLog },
  data() {
    return {
      filters: {
        busLinesId: ""
      },
      entityName: 'SchedulingTemplate', //操作日记中的表名称
      entityKey: '',  //操作日记中的表的Id
      buttonList: [],
      operationButtonList: [],
      schedulingTemplateList: [], //排班模版列表
      busLinesList: [], //线路列表
      total: 0,
      page: 1,
      pageSize: 10,
      listLoading: false,
      sels: [], //列表选中列
      currentRow: null,
      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      operateDataLogFormVisible: false, //查看操作日记界面是否显示
      editLoading: false,
      addLoading: false,
      editFormRules: {
        BusLinesId: [{ required: true, message: "请选择公交线路", trigger: "blur" }],
        DepartureTemplate: [{ required: true, message: "请输入发车模版名称", trigger: "blur" }]
      },
      //编辑界面数据
      editForm: {
        Id: 0,
        CreateBy: "",
        BusLinesId: 0,
        DepartureTemplate: ""
      },

      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        BusLinesId: [{ required: true, message: "请选择公交线路", trigger: "blur" }],
        DepartureTemplate: [{ required: true, message: "请输入发车模版名称", trigger: "blur" }]
      },
      //新增界面数据
      addForm: {
        CreateBy: "",
        CreateId: "",
        BusLinesId: 0,
        DepartureTemplate: ""
      }
    };
  },
  methods: {
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this.filters = {
        busLinesId: item.busLinesId
      };
      this.getSchedulingTemplateList();
      if (item.Func !== undefined)
        this[item.Func].apply(this, item);
    },
    operationButtonFunction(item,row){
      this.currentRow = row;
      this[item.Func].apply(this,item);
    },
    formatModifyTime: function(row, column) {
      return !row.ModifyTime || row.ModifyTime == ""
        ? ""
        : util.formatDate.format(new Date(row.ModifyTime), "yyyy-MM-dd hh:mm:ss");
    },
    handleSizeChange(val) {
      this.page = 1;
      this.pageSize = val;
      this.getSchedulingTemplateList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getSchedulingTemplateList();
    },
    querySchedulingTemplate(){
      this.page = 1;
      this.getSchedulingTemplateList();
    },
    //获取排班模版列表
    getSchedulingTemplateList() {
      let _this = this;
      let para = {
        busLinesId: _this.filters.busLinesId,
        page: _this.page,
        pageSize: _this.pageSize
      };
      _this.listLoading = true;
      getSchedulingTemplateListPage(para).then(res => {
        _this.total = res.data.response.dataCount;
        _this.schedulingTemplateList = res.data.response.data;
        _this.listLoading = false;
      });
    },
    getBusLinesList(pageSizePara){
      getBusLinesListPage(pageSizePara).then(res => {
        this.busLiness = res.data.response.data;
        this.filters.busLinesId = res.data.response.data.length > 0?res.data.response.data[0].Id:"";
        this.getSchedulingTemplateList();
      });
    },
  
    //删除
    handleDel() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error"
        });

        return;
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning"
      })
        .then(() => {
          this.listLoading = true;
          let para = { id: row.Id };
          removeSchedulingTemplate(para).then(res => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success"
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error"
              });
            }

            this.querySchedulingTemplate();
          });
        })
        .catch(() => {});
    },
    //显示编辑界面
    handleEdit() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error"
        });

        return;
      }

      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);
    },
    //显示新增界面
    handleAdd() {
      this.addFormVisible = true;
      this.addForm = {
        CreateBy: "",
        BusLinesId: this.filters.busLinesId
      };
    },
    //查看操作日记
    lookUpOperateDataLog() {
      this.operateDataLogFormVisible = true;
      this.entityKey = this.currentRow.Id;
    },
    //编辑
    editSubmit: function() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            let para = Object.assign({}, this.editForm);

            editSchedulingTemplate(para).then(res => {
              if (util.isEmt.format(res)) {
                this.editLoading = false;
                return;
              }

              if (res.data.success) {
                this.editLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success"
                });
                this.$refs["editForm"].resetFields();
                this.editFormVisible = false;
                this.querySchedulingTemplate();
              } else {
                this.editLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "error"
                });
              }
            });
          })
          .catch(() => {
          
          });
        }
      });
    },
    //新增
    addSubmit: function() {
      let _this = this;
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            let para = Object.assign({}, this.addForm);

            var user = JSON.parse(window.localStorage.user);

            if (user && user.uID > 0) {
              para.CreateId = user.uID;
              para.CreateBy = user.uRealName;
            } else {
              this.$message({
                message: "用户信息为空，先登录",
                type: "error"
              });
              _this.$router.replace(
                _this.$route.query.redirect ? _this.$route.query.redirect : "/"
              );
            }

            addSchedulingTemplate(para).then(res => {
              if (util.isEmt.format(res)) {
                this.addLoading = false;
                return;
              }
              if (res.data.success) {
                this.addLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success"
                });
                this.$refs["addForm"].resetFields();
                this.addFormVisible = false;
                this.querySchedulingTemplate();
              } else {
                this.addLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "error"
                });
              }
            });
          })
          .catch(() => {
          
          });
        }
      });
    },
    selsChange: function(sels) {
      this.sels = sels;
    },
    getButtonList2(routers) {
      let _this = this;
      routers.forEach(element => {
        let path = this.$route.path.toLowerCase();
        if (element.path && element.path.toLowerCase() == path) {
          _this.buttonList = element.children;
          return;
        } else if (element.children) {
          _this.getButtonList(element.children);
        }
      });
    }
  },
  mounted() {
    let pageSizePara = {
      pageSize: 100
    };
    this.getBusLinesList(pageSizePara);

    getBusLinesListPage(pageSizePara).then(res => {
      this.busLinesList = res.data.response.data;
    });

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    //第一种写法，每个页面都需要写方法，但是可以做特性化处理
    // this.getButtonList(routers);
    
    //第二种写法，封装到 permissionRouter.js 中
    this.buttonList = getButtonList(this.$route.path, routers);
    this.operationButtonList = getOperationButtonList(this.$route.path, routers);
  }
}
</script>

<style scoped>

</style>
